import { NetworkId } from '@/types/network'
import { match } from 'ts-pattern'
import { Hex } from 'viem'

export function getSurveyFactoryAddress(chainId: NetworkId) {
	const address = match(chainId)
		// Spicy
		.with(88882, () => '0xf2d976082CadDf54AA82eCA5619f8dA957438F32')
		// Staging
		.with(88883, () => '0x84DadD61754c25A8b630e1E16E5421DA17D14AdB')
		// Mainnet
		.with(88888, () => '0x8378bc489a222a9afe7afD7aaDCbEF42EbB1fF00') // dummy one is 0x9f8412011706e273a19e89B2d64C55a9DfA1a2df
		.exhaustive()

	return address as Hex
}
